import styled from 'styled-components'
import { Container, Row, Col } from "react-bootstrap";
import Image from 'react-bootstrap/Image'
import { LinkList } from '../profile/linkList';
import { FaPhone } from 'react-icons/fa';
import { AiOutlineMail, AiOutlineShareAlt, AiOutlineWhatsApp } from 'react-icons/ai';
import { RWebShare } from 'react-web-share';
import { ImagesCarousel } from '../image/ImageCarousel';
import { DEFAULT_BACKGROUND_COLOR, DEFAULT_TEXT_COLOR, DEFAULT_PROFILE_IMG } from '../../DEFAULTS';
import { CookieConsent } from 'react-cookie-consent';

const OptionIcon = styled.a`
  cursor: pointer;
  text-decoration: none;
  background-color: transparent;
  border: none;
  color: ${(props) => props.color};
  :hover {
    color: ${(props) => props.color};
    filter: brightness(80%);
  }
`;

export const BusinessPage = ({ card }) => {
  const iconOptionColor = card?.settings?.descriptionTextColor || DEFAULT_TEXT_COLOR;
  const ICONS_SIZE = "1.8em";
  let phoneWith34 = card?.phone;
  if (card?.phone?.length === 9) {
    phoneWith34 = `34${card?.phone}`;
  };

  return (
    <div id="main" style={{
      color: iconOptionColor,
      background: card?.settings?.backgroundImage
        ? `url(${card?.settings?.backgroundImage}) no-repeat center center fixed`
        : card?.settings?.backgroundColor || DEFAULT_BACKGROUND_COLOR,
    }}>
      <Container className="container">
        <Row className="profile">
          <Col>
            <Image
              roundedCircle
              src={`${card.imageUrl || DEFAULT_PROFILE_IMG}`}
              className="profileImage"
              alt="profile"
            />
          </Col>
          <Row className="websiteName text-center">
            {card?.name && (<span> {`${card.name}`} </span>)}
          </Row>
        </Row>
        <Row className="profileOptions justify-content-md-center">
          <Col xs="1" md="2" lg="3">
          </Col>
          <Col>
            <Row style={{ padding: "5px 0px" }}>
              {card.showPhoneNumber && <Col>
                <OptionIcon color={iconOptionColor}
                  href={`tel:${card?.phone === '611900888' ? '854727333' : card?.phone?.replace(/[+]/g, '')}`}>
                  <FaPhone size={ICONS_SIZE} />
                  <p className="textWithIcon"> Llamar </p>
                </OptionIcon>
              </Col>}
              {card.showEmail && <Col>
                <OptionIcon color={iconOptionColor} href={`mailto:${card?.email}`}>
                  <AiOutlineMail size={ICONS_SIZE} />
                  <p className="textWithIcon"> Email </p>
                </OptionIcon>
              </Col>}
              <Col>
                <RWebShare
                  data={{
                    text: `Visita mi perfil en `,
                    url: card?.domain === "cebrianasesores"
                      ? "https://www.cebrianasesores.es/tarjetadigital/"
                      : `https://www.tdsur.es/${card.domain}`,
                    title: `Compartir perfil`,
                  }}
                  onClick={() => console.log("shared successfully!")}
                  sites={["facebook", "whatsapp", "telegram", "mail"]}
                >
                  <OptionIcon href='#' color={iconOptionColor} >
                    <AiOutlineShareAlt size={ICONS_SIZE} />
                    <p className="textWithIcon"> Compartir </p>
                  </OptionIcon>
                </RWebShare>
              </Col>
            </Row>
          </Col>
          <Col xs="1" md="2" lg="3">
          </Col>
        </Row>
        <Row className="text-center">
          <span>
            <div dangerouslySetInnerHTML={{ __html: card?.description }} />
          </span>
        </Row>
        <LinkList tenantInfo={card} />
        {card?.image1 && <Row>
          <Col xs="0" md="2" lg="3"></Col>
          <Col xs="12" md="8" lg="6">
            <ImagesCarousel tenantInfo={card} />
          </Col>
          <Col xs="0" md="2" lg="3"></Col>
        </Row>}
        <Row>
          <Col>
            {card.qr && <Image src={card.qr} style={{ width: "300px", height: "300px" }} />}
          </Col>
        </Row>
        <a href={`https://api.whatsapp.com/send?phone=${phoneWith34}`}>
          <AiOutlineWhatsApp className="float" />
        </a>

        {card.reviewsLink &&
          (<a href={card.reviewsLink}>
            <Image src="./gracias1.png" style={{ height: "50px" }} />
          </a>)
        }
        <CookieConsent
          buttonText="ACEPTAR"
          cookieName="TDSURCOOKIE"
          declineButtonText="RECHAZAR"
          declineCookieValue="tdsur_declined"
          setDeclineCookie
          enableDeclineButton
          style={{
            background: "black",
            border: "white 2px"
          }}
          buttonStyle={{
            background: "white",
            color: "black",
            fontWeight: "bold",
          }}
        >
          Este sitio web usa cookies para mejorar su experiencia{" "}
          <span style={{ fontSize: "12px" }}>Usted puede aceptar o rechazar su uso en cualquier momento de acuerdo con nuestra política de privacidad y cookies</span>
        </CookieConsent>
      </Container>
    </div>
  );
};
